import { render, staticRenderFns } from "./PageMainStart.vue?vue&type=template&id=1e9ed418&scoped=true&"
import script from "./PageMainStart.vue?vue&type=script&lang=js&"
export * from "./PageMainStart.vue?vue&type=script&lang=js&"
import style0 from "./PageMainStart.vue?vue&type=style&index=0&id=1e9ed418&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e9ed418",
  null
  
)

export default component.exports